import "@patternfly/react-core/dist/styles/base.css";
import React from "react";
import {
  Nav,
  NavExpandable,
  NavItem,
  NavList,
  Page,
  PageSection,
  PageSectionVariants,
  PageSidebar,
  PageSidebarBody
} from "@patternfly/react-core";
import {NavLink} from 'react-router';
import TornadoesMasthead from "./TornadoesMasthead";

const TornadoesPageLayout = ({ children}) => { 
  const [activeGroup, setActiveGroup] = React.useState("itemHome");
  const [activeItem, setActiveItem] = React.useState("itemHome");

  const onNavSelect = ({ itemId, groupId }) => {
    setActiveGroup(groupId);
    setActiveItem(itemId);
  };
  
  const PageNav = (
    <Nav onSelect={onNavSelect} aria-label="Nav">
      <NavList>
        <NavItem key='nav-home-link' itemId="itemHome" groupId="itemHome" isActive={activeItem === "itemHome"}>
          <NavLink to="/">Home</NavLink>
        </NavItem>
        <NavExpandable
          title="Our Teams"
          groupId="grpTeams"
          isActive={activeGroup === "grpTeams"}
        >
          <NavItem
            key='nav-10u-passante-link' 
            groupId="grpTeams"
            itemId="grp10uPassanteTeam"
            isActive={activeItem === "grp10uPassanteTeam"}
          >
            <NavLink to="/10u-passante">10U Passante</NavLink>
          </NavItem>
          <NavItem
            key='nav-12u-beard-link' 
            groupId="grpTeams"
            itemId="grp12uBeardTeam"
            isActive={activeItem === "grp12uBeardTeam"}
          >
            <NavLink to="/12u-beard">12U Beard</NavLink>
          </NavItem>
          <NavItem
            key='nav-12u-beck-link' 
            groupId="grpTeams"
            itemId="grp12uBeckTeam"
            isActive={activeItem === "grp12uBeckTeam"}
          >
            <NavLink to="/12u-beck">12U Beck</NavLink>
          </NavItem>
          <NavItem
            key='nav-14u-gentile-link' 
            groupId="grpTeams"
            itemId="grp14uGentileTeam"
            isActive={activeItem === "grp14uGentileTeam"}
          >
            <NavLink to="/14u-gentile">14U Gentile</NavLink>
          </NavItem>
          <NavItem
            key='nav-14u-green-link' 
            groupId="grpTeams"
            itemId="grp14uGreenTeam"
            isActive={activeItem === "grp14uGreenTeam"}
          >
            <NavLink to="/14u-green">14U Green</NavLink>
          </NavItem>
          <NavItem
            key='nav-16u-culligan-link' 
            groupId="grpTeams"
            itemId="grp16uCulliganTeam"
            isActive={activeItem === "grp16uCulliganTeam"}
          >
            <NavLink to="/16u-culligan">16U Culligan</NavLink>
          </NavItem>
        </NavExpandable>
        <NavExpandable
          title="About"
          groupId="grpAbout"
          isActive={activeGroup === "grpAbout"}
        >
          <NavItem
            key='nav-news-link' 
            groupId="grpAbout"
            itemId="grpNews"
            isActive={activeItem === "grpNews"}
          >
            <NavLink to="/news">Latest News</NavLink>
          </NavItem>
          <NavItem
            key='nav-contacts-link' 
            groupId="grpAbout"
            itemId="grpContacts"
            isActive={activeItem === "grpContacts"}
          >
            <NavLink to="/contacts">Contacts</NavLink>
          </NavItem>
        </NavExpandable>
	      <NavItem key='nav-store-link' itemId="itemStore" isActive={activeItem === "itemStore"}>
          <NavLink to="/store">Tornadoes Gear</NavLink>
        </NavItem>
      </NavList>
    </Nav>
  );

  const Sidebar = <PageSidebar>
    <PageSidebarBody>{PageNav}</PageSidebarBody>
  </PageSidebar>;
  const pageId = "main-content-page-layout-expandable-nav";

  return (
    <Page
      masthead={<TornadoesMasthead />}
      sidebar={Sidebar}
      isManagedSidebar
      mainContainerId={pageId}
    >
      <PageSection variant={PageSectionVariants.light}>
        {children}
      </PageSection>
    </Page>
  );
};

export default TornadoesPageLayout;
